"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.Container = exports.Box = void 0;
const react_1 = __importDefault(require("react"));
const view_1 = __importDefault(require("./view"));
const Box = (props) => react_1.default.createElement(view_1.default, Object.assign({}, props));
exports.Box = Box;
const Container = (props) => react_1.default.createElement(view_1.default, Object.assign({ container: true }, props));
exports.Container = Container;
const Item = (props) => react_1.default.createElement(view_1.default, Object.assign({ item: true }, props));
exports.Item = Item;
__exportStar(require("./types"), exports);
